import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
export const IconWiki = props => {
    return (React.createElement(SvgIcon, Object.assign({ viewBox: "0 0 24 24", fontSize: "small" }, props),
        React.createElement("path", { d: "M20 0v2h-18v18h-2v-20h20zm-7.281 20.497l-.719 3.503 3.564-.658-2.845-2.845zm8.435-8.436l2.846 2.845-7.612 7.612-2.845-2.845 7.611-7.612zm-17.154-8.061v20h6v-2h-4v-16h16v4.077l2 2v-8.077h-20z" })));
};
//# sourceMappingURL=IconWiki.js.map